import { useState, useEffect, useRef } from "react";
import {
    FormGroup,
    Label,
    Button,
    Alert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import styled from '@emotion/styled';
import client from '../../common/api';

import BillingWarning from '../BillingWarning';
import ThumbnailModal from './ThumbnailModal';

const ThumbnailWrapper = styled.div`

    .roadmap-thumbnail-preview {
        width: 50%;
        height: 75px;
        margin-bottom: 10px;
        text-align: left;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 8px;
        }
    }
    .thumbnail-upload-btn {
        border-color: #E1E4EA;
        border-radius: 8px;
        color: #525866;

        &:hover {
            background-color: #E1E4EA;
        }
    }
`;

const PostThumbnail = ({
    billingDetails,
    updateRoadmapPayload,
    roadmapPayload,
    thumnailLocation,
    isEditable
}) => {
    const [showAlert, setShowAlert] = useState({
        show: false,
        type: '',
        message: '',
    });
    const [thumbnailInfo, setThumbnailInfo] = useState({
        file: '',
        name: '',
    });
    const [showThumbnailModal, setShowThumbnailModal] = useState(false);
    const {
        plan_info,
    } = billingDetails || {};
    const isThumbnailAllowed = plan_info?.thumbnail_allowed;
    // const showPublicThumbnail = (isThumbnailAllowed && thumnailLocation === 'public' && roadmapPayload.thumbnail);

    const thumbnail_img = useRef(null);

    const hideAlert = () => {
        setTimeout(() => {
            setShowAlert({
                show: false,
                type: '',
                message: '',
            });
        }, 2000);
    };

    const onUploadClick = (event) => {
        event.preventDefault();
        if (!thumbnail_img || !thumbnail_img.current) return;
        thumbnail_img.current.click();
    };

    const uploadThumbnail = (_file) => {
        const formData = new FormData();
        formData.append('file', _file);
        // formData.append('activeSpaceName', activeSpace);

        client.post('/feedback/upload/thumbnail', formData).then(response => {
            const thumbnailResp = response.data;
            console.log('thumbnailResp--->', thumbnailResp);
            if (thumbnailResp.success) {
                // setShowAlert({
                //     show: true,
                //     type: 'success',
                //     message: 'Thumbnail uploaded successfully',
                // });
                updateRoadmapPayload({
                    ...roadmapPayload,
                    thumbnail: thumbnailResp.data.thumbnail_url,
                });
            } else {
                setShowAlert({
                    show: true,
                    type: 'danger',
                    message: thumbnailResp.msg,
                });
            }
            hideAlert();
        })
    };

    const thumbnailImgHandler = (e) => {
        const file = e.target.files[0];
        const sizeInKB = (file.size / (1024)).toFixed(1);

        if (sizeInKB > 2000) {
            setShowAlert({
                show: true,
                type: 'danger',
                message: 'File size should be less than 2mb'
            });
            return;
        }
        setThumbnailInfo({
            file,
            name: file.name,
        });
    };

    const removeThumbnail = () => {
        setThumbnailInfo({
            file: '',
            name: '',
        });
        updateRoadmapPayload({
            ...roadmapPayload,
            thumbnail: '',
        });
    };

    const getThumbnailLabel = () => {
        const thumbnailAdded = roadmapPayload.thumbnail;

        let label = 'Thumbnail';
        if (thumnailLocation === 'dashboard' && !thumbnailAdded) {
            label = 'Add Thumbnail';
        } else if (thumnailLocation === 'dashboard' && thumbnailAdded) {
            label = 'Thumbnail';
        } else if (thumnailLocation === 'public' && !thumbnailAdded) {
            label = '';
        }
        return label;
    };

    const showPublicThumbnail = () => {
        let showThumbnail = false;
        if (thumnailLocation === 'dashboard') {
            showThumbnail = true;
        } else if (thumnailLocation === 'public' && roadmapPayload.thumbnail) {
            showThumbnail = true;
        }
        return showThumbnail;
    }

    useEffect(() => {
        if (thumbnailInfo.file) {
            uploadThumbnail(thumbnailInfo.file);
        }
    }, [thumbnailInfo.file]);

    return (
        <ThumbnailWrapper >
            {
                showPublicThumbnail() && (
                    <FormGroup className="roadmap-thumbnail-upload" disabled={!isThumbnailAllowed}>
                        <Label for="exampleFile">{getThumbnailLabel()}</Label>
                        <input
                            id="exampleFile"
                            hidden
                            name="file"
                            type="file"
                            disabled={!isThumbnailAllowed}
                            ref={thumbnail_img}
                            accept="image/png, image/jpeg"
                            onChange={thumbnailImgHandler}
                        />
                        {
                            isThumbnailAllowed && (
                                <div>
                                    {
                                        roadmapPayload.thumbnail && (
                                            <div
                                                className="roadmap-thumbnail-preview"
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        setShowThumbnailModal(true);
                                                    }
                                                }}
                                                onClick={() => setShowThumbnailModal(true)}
                                            >
                                                <img src={roadmapPayload.thumbnail} alt="thumbnail" />
                                            </div>
                                        )
                                    }

                                    {/* dont show remove button in public view */}
                                    {
                                        thumnailLocation === 'dashboard' && (
                                            <>
                                                {
                                                    roadmapPayload.thumbnail && (
                                                        <Button size="sm" color="danger"
                                                            outline className=""
                                                            onClick={removeThumbnail}
                                                            disabled={!isEditable}
                                                        >Remove</Button>
                                                    )
                                                }
                                                <Button size="sm"
                                                    color="primary"
                                                    id="upload-thumbnail-tooltip"
                                                    outline className="thumbnail-upload-btn"
                                                    onClick={onUploadClick}
                                                    disabled={!isEditable}
                                                >
                                                    {
                                                        roadmapPayload.thumbnail ? 'Change' : 'Upload'
                                                    }
                                                </Button>
                                                {
                                                    showAlert.show && (
                                                        <Alert color={showAlert.type} style={{ padding: '2px 5px', fontSize: '11px', marginBottom: '0', marginTop: '5px' }}>
                                                            {showAlert.message}
                                                        </Alert>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            )
                        }
                        {/* enlarged thumbnail view */}
                        <ThumbnailModal
                            roadmapPayload={roadmapPayload}
                            showThumbnailModal={showThumbnailModal}
                            setShowThumbnailModal={setShowThumbnailModal}
                        />


                        {/* <FormText>
                    This is some placeholder block-level help text for the above input. It‘s a bit lighter and easily wraps to a new line.
                </FormText> */}
                        {
                            (!isThumbnailAllowed && thumnailLocation === 'dashboard') && (
                                <BillingWarning
                                    compactVersion
                                    heading="Upgrade to Pro to add thumbnail"
                                    bodyText="Your current plan does not support thumbnail setup. Please upgrade to enable this feature."
                                    learnMoreLink="https://help.productlogz.com/create-your-roadmap/add-thumbnails-to-your-roadmap-items"
                                />
                            )
                        }
                    </FormGroup>
                )
            }
        </ThumbnailWrapper>
    );
};

export default PostThumbnail;
